import { resolveCmsAsset } from "./media";

export function normalizeAchievementSlug(value) {
  return String(value || "")
    .trim()
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
}

export function getAchievementSlug(achievement) {
  return normalizeAchievementSlug(achievement.slug || achievement.title);
}

export function getAchievementPath(achievement) {
  return `/realisations/${getAchievementSlug(achievement)}`;
}

export function getAchievementImage(achievement) {
  if (achievement.imageUrl) return resolveCmsAsset(achievement.imageUrl);
  if (achievement.image?.name) return resolveCmsAsset(`/image/${achievement.image.name}`);
  return resolveCmsAsset("/assets/images/mission.jpg");
}
